<template>
  <div>
    <div>
      <edit-train-configuration
        @close_modal="hide_train_config_modal"
        :train_config="train_config_in_modal"
        v-if="edit_mode"
        :is_new_train_conf="is_new_train_conf"
        :is_copy="is_copy"
        :models="models"
      ></edit-train-configuration>
    <treshold-slider v-model="threshold"></treshold-slider>
    <div v-if="showTrainLimitReachedAlert">
      <show-alert :alert-message="$t(trainLimitReachedMessage)"></show-alert>
    </div>
    <v-row v-if="canManageTrainConfigs" class="mb-3" dense>
      <v-col cols="auto">
        <v-btn color="primary" @click="addTrainConfig">
          {{ $t('models_and_train_configs.button_add_train_config') }}
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <import-model-button @imported="reload"></import-model-button>
      </v-col>
      <v-col v-if="showOnboardingPanel" cols="auto">
        <v-btn
          variant="outlined"
          color="primary"
          :loading="bootstrapping"
          @click="bootstrapTrainConfig"
        >
          {{ $t('models_onboarding.generate_button') }}
        </v-btn>
      </v-col>
    </v-row>
    <models-onboarding-panel
      v-if="showOnboardingPanel"
      :show-generate-button="false"
      @created="onOnboardingCreated"
    />
    <v-row dense align="center" class="mb-2">
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          :label="$t('models_and_train_configs.search')"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-checkbox
          v-model="show_archived"
          :label="$t('models_and_train_configs.show_archived')"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
    <loader :loading="loading || !models_loaded || rowActionLoading"></loader>
    <v-data-table-server
          v-if="!showOnboardingPanel"
          v-model:page="options.page"
          v-model:items-per-page="options.itemsPerPage"
          v-model:sort-by="options.sortBy"
          :loading="loading || !models_loaded || rowActionLoading"
          :items="items"
          :headers="headers"
          @update:options="onOptionsUpdate"
          :items-length="totalItems"
        >
        <template v-slot:item.name="{ item }" >

            <train-config-name-cell
            :train_config="item"
            :jobs="jobs"
            :models="item.relationships.models"
            @show_train_config_modal="show_train_config_modal"
            @copy_train_config="copy_train_config"
            @load_items="reload"
            @archived="reload"
            @row-busy="setRowActionLoading"
            ></train-config-name-cell>
          </template>
      <template v-slot:item.tags="{ item }" >
        <train-config-tags-cell :train_config="item"></train-config-tags-cell>
      </template>
        <template v-slot:item.jobs="{ item }" >
            <train-config-training-state-cell
            :train_config="item"
            :jobs="jobs"
            :models="item.relationships.models"
            ></train-config-training-state-cell>
          </template>
        <template v-slot:item.models="{ item }" >
            <train-config-models-and-performance-cell
            :train_config="item"
            :jobs="jobs"
            :models="item.relationships.models"
            :threshold="threshold"
            @models-changed="reload"
            ></train-config-models-and-performance-cell>
          </template>
        <template v-slot:item.updated_at="{ item }" >
            <train-config-last-updated-cell
            :train_config="item"
            ></train-config-last-updated-cell>
          </template>
        <template v-slot:item.repeat_after_days="{ item }" >
            <train-config-repeat-after-days-cell
            :train_config="item"
            ></train-config-repeat-after-days-cell>
          </template>
        <template v-slot:item.actions="{ item }">
          <train-config-actions-cell
          :train_config="item"
          :models="item.relationships.models"
          :jobs="jobs"
          @load_jobs_request="load_jobs"
          @train-limit-reached="handleTrainLimitReached"
          :trainLimitReached="showTrainLimitReachedAlert"
          ></train-config-actions-cell>
        </template>
      </v-data-table-server>
    </div>
  </div>
</template>

<script>

import LoadTrainConfigsMixin from "@/mixins/LoadTrainConfigsMixin";
import ApiDatatableMixin from "@/mixins/ApiDatatableMixin";
import TrainingsWebSocketMixin from "@/mixins/TrainingsWebSocketMixin";
import EditTrainConfiguration from "@/components/EditTrainConfiguration";
import TresholdSlider from "@/components/train_configs_and_models/TresholdSlider.vue";
import ShowAlert from "@/components/ShowAlert.vue";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";
import { vuetifyHeaders } from "@/utils/vuetifyHeaders";

import TrainConfigNameCell from '@/components/train_configs_and_models/TrainConfigNameCell.vue';
import TrainConfigTrainingStateCell from '@/components/train_configs_and_models/TrainConfigTrainingStateCell.vue';
import TrainConfigModelsAndPerformanceCell from '@/components/train_configs_and_models/TrainConfigModelsAndPerformanceCell.vue';
import TrainConfigLastUpdatedCell from '@/components/train_configs_and_models/TrainConfigLastUpdatedCell.vue';
import TrainConfigRepeatAfterDaysCell from '@/components/train_configs_and_models/TrainConfigRepeatAfterDaysCell.vue';
import TrainConfigActionsCell from '@/components/train_configs_and_models/TrainConfigActionsCell.vue';
import TrainConfigTagsCell from "@/components/train_configs_and_models/TrainConfigTagsCell.vue";
import ModelsOnboardingPanel from "@/components/models/ModelsOnboardingPanel.vue";
import ImportModelButton from "@/components/train_configs_and_models/ImportModelButton.vue";
import Loader from "@/components/layout/loader.vue";
import LoadModelsMixin from "@/mixins/LoadModelsMixin";


export default {
  name: "ModelsAndTrainConfigs",
  mixins: [LoadTrainConfigsMixin, LoadModelsMixin, ApiDatatableMixin, CurrentUserMixin, TrainingsWebSocketMixin],
  components: {
    Loader,
    TrainConfigTagsCell,
    ModelsOnboardingPanel,
    ImportModelButton,
    EditTrainConfiguration, TrainConfigActionsCell, TrainConfigNameCell, TrainConfigTrainingStateCell, TrainConfigModelsAndPerformanceCell,
              TrainConfigLastUpdatedCell, TrainConfigRepeatAfterDaysCell, TresholdSlider, ShowAlert},
  data () {
    return {
      'options': { page: 1, itemsPerPage: 10, sortBy: [{ key: 'updated_at', order: 'desc' }] },
      'show_archived': false,
      'train_config_in_modal': null,
      'api_model': 'train_config',
      'edit_mode': false,
      'item' : "",
      'jobs': [],
      'threshold': 60,
      'showTrainLimitReachedAlert': false,
      'itemsLoaded': false,
      'is_new_train_conf': false,
      'is_copy': false,
      'bootstrapping': false,
      'rowActionLoading': false,
      'hasAnyTrainConfigs': false,
    }
  },
  mounted() {
    this.load_jobs();
    this.setupTrainingsSocket();
    this.loadTrainConfigs();
  },
  watch: {
    currentProjectId() {
      this.load_jobs();
      this.setupTrainingsSocket();
      this.itemsLoaded = false;
    },
    totalItems() {
      this.itemsLoaded = true;
    },
  },
  methods: {
    setRowActionLoading(value) {
      this.rowActionLoading = value;
    },
    handleTrainLimitReached() {
      this.showTrainLimitReachedAlert = true
    },
    show_train_config_modal(train_config) {
      if(!train_config) {
        return
      }
      this.is_new_train_conf = false;
      this.is_copy = false;
      this.train_config_in_modal = train_config;
      this.edit_mode = true;
    },
    copy_train_config(train_config) {
      this.is_new_train_conf = true;
      this.is_copy = true;
      this.train_config_in_modal = {
        name: train_config.name + ' Copy',
        description: train_config.description,
        meta: train_config.meta,
      };
      this.edit_mode = true;
    },
    async hide_train_config_modal() {
      await this.reload();
      this.train_config_in_modal = null;
      this.edit_mode = false;
      this.is_new_train_conf = false;
      this.is_copy = false;
    },
    async loadTrainConfigs() {
      await this.loadItems();
      if (this.totalItems > 0) {
        this.hasAnyTrainConfigs = true;
      } else if (!this.hasAnyTrainConfigs) {
        const archived = await this.$api.train_config.all(
          this.options,
          this.filter,
          undefined,
          true,
        );
        if (archived && archived.total > 0) {
          this.hasAnyTrainConfigs = true;
        }
      }
      this.itemsLoaded = true;
    },
    async onOnboardingCreated() {
      await this.reload();
    },
    addTrainConfig() {
      this.is_new_train_conf = true;
      this.is_copy = false;
      this.train_config_in_modal = {
        name: '',
        description: '',
        meta: JSON.stringify({ label_ids: [], model_type: 'bounding_box' }),
      };
      this.edit_mode = true;
    },
    async bootstrapTrainConfig() {
      this.bootstrapping = true;
      try {
        const result = await this.$api.onboarding.bootstrapTrainConfig();
        if (result && result.error) {
          const key = `models_onboarding.error_${result.error}`;
          const msg = this.$te(key) ? this.$t(key) : result.error;
          this.$store.dispatch('snackbars/add_failed_snack', msg);
          return;
        }
        this.$store.dispatch('snackbars/add_success_snack', {
          message: this.$t('models_onboarding.success'),
        });
        await this.onOnboardingCreated();
      } finally {
        this.bootstrapping = false;
      }
    },
    async load_jobs() {
      const jobs = await this.$api.job.get_active_jobs('train');
      if (jobs) {
        this.jobs = jobs;
      }
    },
    async reload() {
      await this.loadTrainConfigs();
      await this.$store.dispatch('model/all', { force_reload: true });
    },
  },
  computed: {
    currentProjectId() {
      return this.$store.getters['user/get_current_project_id'];
    },
    trainLimitReachedMessage() {
      return this.getLimitMessage('models_and_train_configs', 'TRAIN_LIMIT');
    },
    models () {
      return this.$store.getters['model/get_items']
    },
    canManageTrainConfigs() {
      return this.is_admin || this.is_manager || this.is_project_owner;
    },
    showOnboardingPanel() {
      // Only show onboarding panel when:
      // 1. Items are loaded
      // 2. Not currently loading
      // 3. No train configs exist ever
      // 4. No filter is applied (user hasn't searched/filter yet)
      // 5. Total items is 0
      return (
        this.itemsLoaded &&
        !this.loading &&
        !this.hasAnyTrainConfigs &&
        this.filter === '' &&
        this.totalItems === 0
      );
    },
    headers() {
      return vuetifyHeaders([
        { text: this.$t('models_and_train_configs.name'), value: 'name', sortable: true },
        { text: 'Tags', value: 'tags', sortable: false },
        { text: this.$t('models_and_train_configs.training_state'), value: 'jobs', sortable: false },
        { text: this.$t('models_and_train_configs.models_and_performance'), value: 'models', sortable: false },
        { text: this.$t('models_and_train_configs.last_updated'), value: 'updated_at', sortable: true },
        { text: this.$t('models_and_train_configs.actions'), value: 'actions', sortable: false },
      ]);
    },
  }
}
</script>

<style scoped>

</style>
